import React, { Fragment, useState } from "react";
import { Checkbox, Dropdown, Popover, Radio, Tag } from "antd";

// Images
import searchIcon from "@Images/icons/icon-search.png";
import Ai from "@Images/ai.png";

// Components
import H3Button, { defaultButtonTypes } from "@Uilib/h3Button";
import PRZSelect from "../../../../../Common/UI/PRZSelect";
import H3DateSelector from "@Uilib/h3DateSelector";
import H3Text from "@Uilib/h3Text";
import { FilterOutlined, ControlOutlined } from "@ant-design/icons";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";

// Helpers
import Helpers from "@Apis/helpers";

const AccountPayableInvoiceListTableTitle = ({
  showFilters,
  setShowFilters,
  openPopover,
  setOpenPopover,
  data,
  startDate,
  endDate,
  visibleColumns,
  fixedColumns,
  setVisibleColumns,
  setStartDate,
  setEndDate,
  pushParamsToUrl,
  setApInvoiceSelectedIntervalDateRangeType,
  apInvoiceSelectedIntervalDateRangeType,
  searchKeyword,
  filterState,
  limit,
}) => {
  return (
    <Fragment>
      <div className="doc-list__table-header">
        <div className="doc-list__table-header__left">
          <H3Text
            text={`${data?.count || "0"} Account Payable Invoices`}
            className=""
          />
        </div>
        <div className="doc-list__table-header__right">
          <div className="doc-list__filter-buttons">
            <H3DateSelector
              selectedInterval={apInvoiceSelectedIntervalDateRangeType}
              startDate={startDate}
              endDate={endDate}
              onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                setStartDate(dayjs(date[0])?.startOf("day").valueOf());
                setEndDate(dayjs(date[1])?.endOf("day").valueOf());
                setApInvoiceSelectedIntervalDateRangeType(dateRangeType);
                pushParamsToUrl({
                  currentKeyword: searchKeyword,
                  page: 1,
                  currentLimit: limit,
                  filterState,
                  startDate: dayjs(date[0])?.startOf("day").valueOf(),
                  endDate: dayjs(date[1])?.endOf("day").valueOf(),
                  apInvoiceSelectedIntervalDateRangeType: dateRangeType,
                });
              }}
            />
            <div className="doc-list__action-buttons">
              <div
                className="action-button"
                onClick={() => setShowFilters(!showFilters)}
              >
                <H3Text text="Filters" className="action-button-text" />
                <FilterOutlined />
              </div>
            </div>
            <Dropdown
              overlay={
                <div className="custom-columns__content">
                  <div className="custom-columns__content-section">
                    <H3Text
                      text="Visible Columns"
                      className="custom-columns__content-title"
                    />
                    {Object.keys(visibleColumns)
                      .filter((item) => visibleColumns[item]?.visible)
                      ?.map((key) => (
                        <div key={key}>
                          <Checkbox
                            disabled={fixedColumns.includes(key)}
                            checked={visibleColumns[key]?.visible}
                            onChange={() => {
                              const visibleColumnsCopy = JSON.parse(
                                JSON.stringify(visibleColumns)
                              );
                              visibleColumnsCopy[key].visible =
                                !visibleColumns[key].visible;
                              localStorage.setItem(
                                "prcz-page-columns-ap-invoice",
                                JSON.stringify(visibleColumnsCopy)
                              );
                              setVisibleColumns(visibleColumnsCopy);
                            }}
                          >
                            {visibleColumns[key]?.label}
                          </Checkbox>
                        </div>
                      ))}
                  </div>
                  {Object.keys(visibleColumns).filter(
                    (item) => !visibleColumns[item]?.visible
                  )?.length ? (
                    <div className="custom-columns__content-section">
                      <H3Text
                        text="Hidden Columns"
                        className="custom-columns__content-title"
                      />
                      {Object.keys(visibleColumns)
                        .filter((item) => !visibleColumns[item]?.visible)
                        ?.map((key) => (
                          <div key={key}>
                            <Checkbox
                              disabled={fixedColumns.includes(key)}
                              checked={visibleColumns[key]?.visible}
                              onChange={() => {
                                const visibleColumnsCopy = JSON.parse(
                                  JSON.stringify(visibleColumns)
                                );
                                visibleColumnsCopy[key].visible =
                                  !visibleColumns[key].visible;
                                localStorage.setItem(
                                  "prcz-page-columns-ap-invoice",
                                  JSON.stringify(visibleColumnsCopy)
                                );
                                setVisibleColumns(visibleColumnsCopy);
                              }}
                            >
                              {visibleColumns[key]?.label}
                            </Checkbox>
                          </div>
                        ))}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              }
              trigger={["click"]}
              placement="bottomRight"
            >
              <div className="custom-columns__wrapper">
                Customize Columns
                <ControlOutlined />
              </div>
            </Dropdown>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AccountPayableInvoiceListTableTitle;
